import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { type DropboxOAuthAppUrl, processDropboxOAuthCallback } from './dropboxOAuthSession';

/**
 * Runs on dashboard mount so Dropbox OAuth completes as soon as the user returns
 * from authorize, without waiting for OperationsModal to open.
 */
const DropboxOAuthCallbackHandler = () => {
  const navigate = useNavigate();

  const restoreAppUrl = useCallback(
    ({ pathname, search, hash }: DropboxOAuthAppUrl) => {
      navigate({ pathname, search, hash }, { replace: true });
    },
    [navigate]
  );

  useEffect(() => {
    processDropboxOAuthCallback({ restoreAppUrl }).catch(() => {
      // Errors are surfaced when the user interacts with folder actions.
    });
  }, [restoreAppUrl]);

  return null;
};

export default DropboxOAuthCallbackHandler;
